import { useState } from 'react'
import { css, Theme } from '@emotion/react'
import { Box, Typography, Collapse } from '@mui/material'

import { returnFeed } from '~/utils/returnFeed'

const createData = (
  state: boolean,
  setter,
  question: string,
  answer: string
) => {
  return { state, setter, question, answer }
}

const FAQList = () => {
  const [openOne, setOpenOne] = useState(false)
  const [openTwo, setOpenTwo] = useState(false)
  const [openThree, setOpenThree] = useState(false)

  const rows = [
    createData(
      openOne,
      setOpenOne,
      '社内にウェブに詳しい人間がいない（ウェブ担当がいない）のですが大丈夫でしょうか？',
      'ご安心ください。弊社スタッフが、わかりやすく丁寧にご説明させていただきます。また、他社との比較も含めて、費用面なども明確にお伝えいたしますのでご安心ください。'
    ),
    createData(
      openTwo,
      setOpenTwo,
      'すでにウェブサイトについては頼んでいる会社がありますが大丈夫ですか？',
      'ウェブ広告運用だけのご依頼でも大丈夫です。サイトリニューアルについての無料相談も承っております。成果を最大化するためのご提案をさせていただきますので、ぜひ一度お問合せください。'
    ),
    createData(
      openThree,
      setOpenThree,
      '広告運用のみ、サイト制作のみの依頼もできますか？',
      'もちろんです。広告運用・サイト制作単体でのご依頼も承っておりますので、お気軽にお問い合わせください。'
    ),
  ]

  return (
    <>
      <Box css={styles.faq_container}>
        <Box css={styles.title_container}>
          <Typography color='primary' variant='h2' css={styles.section_title}>
            ご契約・手続きなどについて
          </Typography>
        </Box>
        <ul css={styles.list}>
          {rows.map(row => (
            <li
              key={row.question}
              css={styles.item}
              className={row.state ? 'isActive' : null}>
              <div
                css={styles.accordion_head}
                onClick={() => row.setter(!row.state)}>
                {row.question}
              </div>
              <div>
                <Collapse
                  in={row.state}
                  timeout={{
                    enter: 300,
                    exit: 500,
                  }}
                  unmountOnExit>
                  <div css={styles.accordion_body}>
                    <p>{returnFeed(row.answer)}</p>
                  </div>
                </Collapse>
              </div>
            </li>
          ))}
        </ul>
      </Box>
    </>
  )
}

const styles = {
  faq_container: css`
    margin-left: 0;
    padding: 20px;
  `,
  title_container: css`
    width: 100%;
    padding: 20px 0%;
    border-bottom: 1px solid #dfdddd;
    @media (min-width: 960px) {
      padding: 50px 0;
    }
  `,
  section_title: css`
    font-family: 'Noto sans JP', sans-serif;
    font-weight: 700;
    font-size: 1.5rem;
    text-align: right;
    &:before {
      content: '-';
      margin-right: 1rem;
    }
  `,
  list: css`
    list-style: none;
    padding-inline-start: 0;
    @media (min-width: 960px) {
      margin-left: 50px;
    }
  `,
  item: css`
    cursor: pointer;
    padding-left: 10px;
    border-bottom: 0.2px solid #dfdddd;
  `,
  accordion_head: (theme: Theme) => css`
    position: relative;
    font-family: 'Noto sans JP', sans-serif;
    font-weight: 500;
    font-size: 0.9rem;
    padding: 30px 40px 30px 0;
    color: ${theme.palette.primary.main};
    &:after {
      content: '\\f078';
      font-family: 'Font Awesome 5 Free';
      font-weight: 900;
      position: absolute;
      right: 10px;
      transition: all 0.3s ease-in-out;
    }
    .isActive &:after {
      transform: rotate(180deg);
    }
    @media (min-width: 960px) {
      font-size: 1.2rem;
    }
  `,
  accordion_body: (theme: Theme) => css`
    padding: 20px;
    color: ${theme.palette.primary.main};
  `,
}

export default FAQList
